import { useEffect, useCallback } from "react";
import { useApi, createApiHook } from "../utils/apiUtils";

const useFetchQuestionnaireById = (questionnaireId) => {
  const { apiGet } = useApi();
  const useApiState = createApiHook(null);
  const { data, error, loading, startLoading, setResponse } = useApiState();

  const fetchData = useCallback(async () => {
    if (!questionnaireId) {
      setResponse({ data: null, error: null });
      return;
    }

    startLoading();
    const response = await apiGet(`/questionnaires/${questionnaireId}/show_with_survey`, "Error al obtener el cuestionario");
    setResponse(response);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [questionnaireId]);

  useEffect(() => {
    fetchData();
  }, [fetchData]);

  return { data, error, loading, refetch: fetchData };
};

export default useFetchQuestionnaireById;
